import '@shared/styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { AppProviders } from '@app/providers/AppProviders';
import { routes } from '@app/routes';
import { makeStore, watchUiPersistence } from '@app/store';
import { reloadOnce } from '@shared/lib/staleBuild';

// A file a page needs is gone (a deploy replaced it): reload into the new version.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnce()) event.preventDefault();
});

const store = makeStore();
watchUiPersistence(store);
const router = createBrowserRouter(routes);

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');

createRoot(root).render(
  <StrictMode>
    <AppProviders store={store}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
